export default __webpack_public_path__ + "static/quick-reference-guide_en-d581287107a0de58cb1f287858ddf72c.pdf";